import api from "../utils/api";
import {
  GET_NOTIFICATIONS
} from "./types";

export const get = () => async (dispatch) => {
    try {
        const res = await api.get(`/notifications/me`);

        dispatch({
            type: GET_NOTIFICATIONS,
            payload: res.data,
        });

        return res.data;
    } catch (err) {
        dispatch({
            type: GET_NOTIFICATIONS,
            payload: []
        });
    }
};

export const all = () => async () => {
    try {
        const res = await api.get(`/notifications/me/all`);
        return Array.isArray(res.data) ? res.data : [];
    } catch (err) {
        console.error("Unable to load notification history.", err);
        return null;
    }
};

export const read = (id) => async (dispatch) => {
    try {
        const res = await api.put(`/notifications/me`, { uuid: id });
        if (res.data.success) await dispatch(get());
        return res.data;
    } catch (err) {
        console.error("Unable to mark notification as read.", err);
        return { success: false };
    } 
}

export const readAll = (ids = []) => async (dispatch) => {
    try {
        const uniqueIds = [...new Set(ids.filter(Boolean))];
        await Promise.all(uniqueIds.map((uuid) => api.put(`/notifications/me`, { uuid })));
        await dispatch(get());
        return { success: true };
    } catch (err) {
        console.error("Unable to mark notifications as read.", err);
        return { success: false };
    }
}
